export default __webpack_public_path__ + "static/media/icon-circle-tick.ba356160.svg";